module.exports = __webpack_public_path__ + "img/University-of-Brighton.36d53f09.jpg";